import i18n from '@/i18n'
import { ROUTES } from '@/navigation/constants'
import type { LandingLocale, LocalizedSlugs } from '@/navigation/localeConstants'

export type NewsArticleDefinition = {
    id: string
    slugs: LocalizedSlugs
    title: string
    description: string
    category: string
    authorName: string
    readingMinutes: number
    publishedAt: string
    dateModified: string
    imagePath: string
}

export type NewsArticleMeta = {
    id: string
    slug: string
    title: string
    description: string
    category: string
    readingMinutes: number
    publishedAt: string
    dateModified: string
    authorName: string
    imagePath: string
}

export type NewsArticleBodyProps = {
    article: NewsArticleMeta
}

export function newsArticleI18nKey(id: string, field: string) {
    return `news.articles.${id}.${field}`
}

export const NEWS_ARTICLES: NewsArticleDefinition[] = [
    {
        id: 'ia-hosteleria-ine-2026',
        slugs: {
            es: 'ia-hosteleria-ine-2026',
            en: 'ai-hospitality-ine-2026',
        },
        title: 'Inteligencia artificial en hostelería: el INE dice que un tercio de las empresas ya la usa. Cómo saber si la que te venden te sirve a ti',
        description:
            'El INE publicó el 22 de octubre que el 33,6 % de las empresas usa IA, pero el 94 % de la hostelería queda fuera de la cifra. Tres preguntas para saber si te sirve.',
        category: 'IA · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 9,
        publishedAt: '2026-10-22',
        dateModified: '2026-10-22',
        imagePath: '/actualidad-hostelera/ia-hosteleria-ine-2026/hero.webp',
    },
    {
        id: 'hacemos-cocina-guia-repsol-tipi',
        slugs: {
            es: 'hacemos-cocina-guia-repsol-tipi',
            en: 'hacemos-cocina-repsol-guide-tipi',
        },
        title: 'Hacemos Cocina te paga el primer mes de Tipi: cómo apuntarte y qué pasa el día 31',
        description:
            'Hacemos Cocina, de Guía Repsol, cubre el primer mes de Tipi con 100 albaranes y sin tarjeta. Después, 39 € + IVA al mes. Cupo de 150 licencias. Octubre 2026.',
        category: 'Alianzas · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 8,
        publishedAt: '2026-10-21',
        dateModified: '2026-10-21',
        imagePath: '/actualidad-hostelera/hacemos-cocina-guia-repsol-tipi/hero.webp',
    },
    {
        id: 'verifactu-retraso-2028-hosteleria',
        slugs: {
            es: 'verifactu-retraso-2028-hosteleria',
            en: 'verifactu-delay-2028-hospitality',
        },
        title: 'Retraso de Verifactu a 2028: ya no tienes que cambiar de TPV antes de enero, pero la ley de 2021 sigue en pie',
        description:
            'El 5 de octubre de 2026 Hacienda retrasó Verifactu a 2028. Si ibas a cambiar de TPV antes de enero ya no hay prisa, pero la Ley Antifraude sigue vigente.',
        category: 'Normativa · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 9,
        publishedAt: '2026-10-06',
        dateModified: '2026-10-06',
        imagePath: '/actualidad-hostelera/verifactu-retraso-2028-hosteleria/hero.webp',
    },
    {
        id: 'luz-indexada-o-fija-restaurante',
        slugs: {
            es: 'luz-indexada-o-fija-restaurante',
            en: 'indexed-or-fixed-electricity-restaurant',
        },
        title: '¿Luz indexada o fija en tu restaurante? Lo que tienes que mirar ahora que la luz está en máximos del año',
        description:
            'La luz marcó 201,99 €/MWh el 6 de octubre de 2026. Si tu restaurante tiene luz indexada, cuánto te cuesta de verdad y cuándo compensa pasarse a fijo.',
        category: 'Costes · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 8,
        publishedAt: '2026-10-06',
        dateModified: '2026-10-06',
        imagePath: '/actualidad-hostelera/luz-indexada-o-fija-restaurante/hero.webp',
    },
    {
        id: 'digitalizacion-hosteleria-la-empuja-el-boe',
        slugs: {
            es: 'digitalizacion-hosteleria-la-empuja-el-boe',
            en: 'hospitality-digitization-driven-by-official-gazette',
        },
        title: 'La digitalización de la hostelería no la empuja el retorno. La empuja el BOE',
        description:
            'Verifactu llega en 2027. Por qué la digitalización hostelera entra por obligación, al mínimo, y qué haría distinto un agente tecnológico.',
        category: 'Opinión · Digitalización',
        authorName: 'Samuel Carrillo',
        readingMinutes: 6,
        publishedAt: '2026-09-19',
        dateModified: '2026-09-30',
        imagePath: '/actualidad-hostelera/digitalizacion-hosteleria-la-empuja-el-boe/hero.webp',
    },
    {
        id: 'movil-hosteleria-falta-leve-boe',
        slugs: {
            es: 'movil-hosteleria-falta-leve-boe',
            en: 'phone-use-hospitality-minor-misconduct-boe',
        },
        title: 'Sí, ya puedes sancionar el móvil en tu bar: falta leve, dos días como mucho y diez para hacerlo',
        description:
            'El BOE del 4 de septiembre de 2026 convierte el móvil en falta leve en hostelería: dos días de suspensión como techo y diez para sancionar.',
        category: 'Normativa · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 8,
        publishedAt: '2026-09-17',
        dateModified: '2026-09-17',
        imagePath: '/actualidad-hostelera/movil-hosteleria-falta-leve-boe/hero.webp',
    },
    {
        id: 'sddr-hosteleria-deposito-envases-2026',
        slugs: {
            es: 'sddr-hosteleria-deposito-envases-2026',
            en: 'sddr-hospitality-deposit-return-packaging-2026',
        },
        title: 'SDDR en hostelería: 10 céntimos por lata desde noviembre, y nadie ha escrito todavía quién te los devuelve',
        description:
            'SDDR en hostelería: 10 céntimos por envase desde el 26 de noviembre de 2026. Qué dice la norma, qué sigue sin decidirse y cuánto te cuesta si no vuelve.',
        category: 'Normativa · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 9,
        publishedAt: '2026-09-17',
        dateModified: '2026-09-17',
        imagePath: '/actualidad-hostelera/sddr-hosteleria-deposito-envases-2026/hero.webp',
    },
    {
        id: 'consumo-hosteleria-presupuesto-hogares-2026',
        slugs: {
            es: 'consumo-hosteleria-presupuesto-hogares-2026',
            en: 'why-hospitality-consumption-falls-household-budget-2026',
        },
        title: 'Por qué baja el consumo en hostelería si los hogares tienen 1.057 euros más para gastar',
        description:
            'El gasto de los hogares subió 1.057 € en 2025 y el de restaurantes cayó 92 €, según el INE. Por qué baja el consumo en hostelería y qué mirar en tu carta.',
        category: 'Consumo · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 8,
        publishedAt: '2026-09-17',
        dateModified: '2026-09-17',
        imagePath: '/actualidad-hostelera/consumo-hosteleria-presupuesto-hogares-2026/hero.webp',
    },
    {
        id: 'turista-gasta-menos-restaurantes-2026',
        slugs: {
            es: 'turista-gasta-menos-restaurantes-2026',
            en: 'tourist-spends-less-restaurants-2026',
        },
        title: 'El turista se ha gastado un 10,9 % más este julio (y a tu barra ha llegado menos)',
        description:
            'El turista gastó un 10,9 % más en julio de 2026 y la restauración perdió cuota. Los datos de EGATUR y qué hacer con tu carta antes de octubre.',
        category: 'Turismo · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 7,
        publishedAt: '2026-09-07',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/turista-gasta-menos-restaurantes-2026/hero-terraza.webp',
    },
    {
        id: 'prohibicion-fumar-terrazas-quien-decide-hosteleria-espana',
        slugs: {
            es: 'prohibicion-fumar-terrazas-quien-decide-hosteleria-espana',
            en: 'terrace-smoking-ban-who-really-decides',
        },
        title: 'Prohibición de fumar en terrazas: quién decide de verdad (y qué puede hacer Hostelería de España)',
        description:
            'El Congreso ya tiene el proyecto que prohíbe fumar en terrazas desde el 21 de julio de 2026. Te contamos quién decide y qué puede hacer Hostelería de España.',
        category: 'Normativa · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 8,
        publishedAt: '2026-08-18',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/prohibicion-fumar-terrazas-quien-decide-hosteleria-espana/hero-terraza.webp',
    },
    {
        id: 'rentabilidad-hosteleria-20-anos',
        slugs: {
            es: 'rentabilidad-hosteleria-20-anos',
            en: 'hospitality-profitability-20-years',
        },
        title: 'La rentabilidad en hostelería no ha caído: ha salido a la luz',
        description:
            'El menú del día subió un 19,5% y la comida un 39,2%. Por qué la rentabilidad en hostelería marca récord en los datos oficiales y se hunde en tu caja.',
        category: 'Rentabilidad · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 6,
        publishedAt: '2026-08-12',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/rentabilidad-hosteleria-20-anos/hero-caja.webp',
    },
    {
        id: 'precio-dinamico-restaurantes-coste-vs-demanda',
        slugs: {
            es: 'precio-dinamico-restaurantes-coste-vs-demanda',
            en: 'dynamic-pricing-restaurants-cost-vs-demand',
        },
        title: 'El precio dinámico que sí tiene sentido en tu restaurante (y no es el de Dani García)',
        description:
            'Dani García propuso cobrar más el sábado. Te explicamos por qué el precio dinámico que sí funciona en tu restaurante es otro: el que sigue el coste real.',
        category: 'Precios · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 7,
        publishedAt: '2026-08-07',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/precio-dinamico-restaurantes-coste-vs-demanda/hero-alcachofa.webp',
    },
    {
        id: 'mejor-herramienta-hosteleria-independiente-2026',
        slugs: {
            es: 'mejor-herramienta-hosteleria-independiente-2026',
            en: 'best-tool-independent-hospitality-2026',
        },
        title: '¿Cuál es la mejor herramienta para un bar o restaurante independiente en 2026?',
        description:
            'Precios públicos de Haddock, tspoonlab, Yurest y Tipi, y la facturación mínima que necesitas para que cada una se pague sola. La cuenta que nadie te hace.',
        category: 'Herramientas · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 6,
        publishedAt: '2026-08-04',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/mejor-herramienta-hosteleria-independiente-2026/hero-cuenta.webp',
    },
    {
        id: 'por-que-hosteleria-tarda-digitalizarse-control-costes',
        slugs: {
            es: 'por-que-hosteleria-tarda-digitalizarse-control-costes',
            en: 'why-hospitality-is-slow-to-digitize-cost-control',
        },
        title: 'Por qué la hostelería tarda tanto en digitalizarse (aunque el TPV ya lo hayas aceptado)',
        description:
            'Verifactu obliga a autónomos de hostelería desde el 1 de julio de 2027. Por qué el TPV se digitalizó rápido y el control de costes, todavía no.',
        category: 'Digitalización · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 8,
        publishedAt: '2026-08-03',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/por-que-hosteleria-tarda-digitalizarse-control-costes/hero-tpv.webp',
    },
    {
        id: 'ormuz-subida-precios-hosteleria-otono-2026',
        slugs: {
            es: 'ormuz-subida-precios-hosteleria-otono-2026',
            en: 'hormuz-hospitality-price-rise-autumn-2026',
        },
        title: 'Lo de Ormuz no lo pagas ahora: la subida de precios en hostelería te llega en octubre',
        description:
            'Funcas prevé que la comida suba un 7% después del verano por el bloqueo de Ormuz. El abono tarda 6 meses en llegar a tu albarán: te cae en octubre.',
        category: 'Costes · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 6,
        publishedAt: '2026-07-31',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/ormuz-subida-precios-hosteleria-otono-2026/hero-albaran.webp',
    },
    {
        id: 'el-gobierno-te-paga-el-frigo-nuevo',
        slugs: {
            es: 'el-gobierno-te-paga-el-frigo-nuevo',
            en: 'government-pays-for-your-new-fridge',
        },
        title: 'El Gobierno te paga el frigo nuevo (si llegas de los primeros)',
        description:
            'Plan de choque de 15 M€ para renovar equipamiento en hostelería. Hasta 11.000€ por local, el 100% de la inversión, por orden de llegada desde el 5 de agosto.',
        category: 'Ayudas · Hostelería',
        authorName: 'Samuel Carrillo',
        readingMinutes: 7,
        publishedAt: '2026-07-28',
        dateModified: '2026-09-13',
        imagePath: '/actualidad-hostelera/el-gobierno-te-paga-el-frigo-nuevo/hero-cocina.webp',
    },
]

export function localizeNewsArticle(article: NewsArticleDefinition, locale: LandingLocale): NewsArticleMeta {
    const t = i18n.getFixedT(locale)
    return {
        id: article.id,
        slug: article.slugs[locale],
        title: String(t(newsArticleI18nKey(article.id, 'title'), article.title)),
        description: String(t(newsArticleI18nKey(article.id, 'description'), article.description)),
        category: String(t(newsArticleI18nKey(article.id, 'category'), article.category)),
        readingMinutes: article.readingMinutes,
        publishedAt: article.publishedAt,
        dateModified: article.dateModified,
        authorName: String(t(newsArticleI18nKey(article.id, 'authorName'), article.authorName)),
        imagePath: article.imagePath,
    }
}

export function getNewsArticleById(id: string) {
    return NEWS_ARTICLES.find(a => a.id === id)
}

export function getNewsArticleByLocaleSlug(locale: LandingLocale, slug: string) {
    return NEWS_ARTICLES.find(a => a.slugs[locale] === slug)
}

export function getNewsArticle(slug: string) {
    return getNewsArticleByLocaleSlug('es', slug) ?? getNewsArticleByLocaleSlug('en', slug) ?? getNewsArticleById(slug)
}

export function newsArticlePath(articleOrId: NewsArticleDefinition | string) {
    const article =
        typeof articleOrId === 'string' ? (getNewsArticleById(articleOrId) ?? getNewsArticle(articleOrId)) : articleOrId
    if (!article) return ROUTES.news
    return `${ROUTES.news}/${article.slugs.es}`
}

export function newsArticleLocaleFreePath(article: NewsArticleDefinition) {
    return `${ROUTES.news}/${article.slugs.es}`
}
